export default __webpack_public_path__ + "static/O0251-65c2966b9232dda84d2ab0474f100bb3.png";